import * as administrator from './administrator';

const patch = {
  administrator,
};

export default patch;
